<template>
  <div>
    <BaseFormImportExcel
      v-if="upload.data == null"
      :isUploadFailed="upload.isFailed"
      :uploadedFileName="upload.fileName"
      :templateLink="templateLink"
      :autoPickColumn.sync="autoPickColumn"
      @onUpload="handleUpload"
    />
    <BaseTableImportExcel
      v-else
      :columns="dataTable.columns"
      :rows="dataTable.rows"
      :uploadedHeadColumnNames="upload.headColumnNames"
      :invalid.sync="invalid"
      :autoPickColumn="autoPickColumn"
      @onSelectColumn="handleSelectColumn"
      @onUnselectColumn="handleUnselectColumn"
    />
  </div>
</template>

<script>
import readXlsxFile, { parseExcelDate } from 'read-excel-file'
import BaseFormImportExcel from '../base/BaseFormImportExcel.vue'
import BaseTableImportExcel from '../base/BaseTableImportExcel.vue'
import moment from 'moment'

export default {
  components: {
    BaseFormImportExcel,
    BaseTableImportExcel,
  },

  props: {
    columns: {
      type: Array,
      default: () => ([]),
    },
    templateLink: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      dataTable: {
        columns: [],
        rows: {},
      },
      upload: {
        isFailed: false,
        fileName: null,
        data: null,
        headColumnNames: [],
      },
      invalid: false,
      autoPickColumn: false,
    }
  },

  watch: {
    isValid: {
      handler(value) {
        this.$emit('update:isValid', value)
      },
      immediate: true,
    },
  },

  computed: {
    isValid() {
      return false
    },
  },

  watch: {
    invalid: {
      handler: function() {
        this.$emit('update:invalid', this.invalid)
      },
      immediate: true,
    },
  },

  created() {
    this.initDataTable()
  },

  methods: {
    initDataTable() {
      this.dataTable.columns = this.columns
      this.dataTable.rows = this.dataTable.columns.reduce((acc, col) => {
        return {
          ...acc,
          [col.key]: [],
        }
      }, {})
    },
    getColumnValue(dataType, value) {
      if (!value) {
        return value
      }

      if (dataType == Date) {
        if (typeof value === 'number') {
          return moment(parseExcelDate(value)).format('DD/MM/YYYY').toString()
        }
        return value
      }
      else if (dataType === Number) {
        return this.formatNumberFloat(value)
      }

      return value
    },
    formatNumberFloat (value) {
      if (value == null || value == undefined) {
        return null
      }
      if (Number.isNaN(value * 1)) {
        return value
      }
      value = parseFloat(value)
      return value.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        useGrouping: false,
      })
    },
    validateFile (file) {
      const reg = /(.*?)\.(xlsx)$/
      if (!file.match(reg)) {
        return false
      }
      return true
    },
    getForm(maxRowNumber) {
      const results = []
      for (let rowIndex = 0; rowIndex < maxRowNumber; rowIndex++) {
        const item = {}
        for (const column of this.dataTable.columns) {
          item[column.key] = null
          if (this.dataTable.rows[column.key].length > 0) {
            item[column.key] = this.dataTable.rows[column.key][rowIndex]
          }
        }
        results.push(item)
      }
      return results
    },
    handleUpload(event) {
      try {
        const file = event.target.files[0]
        if (!this.validateFile(file.name)) {
          this.upload.isFailed = true
          this.upload.fileName = file.name
        } else {
          readXlsxFile(file).then((rows) => {
            this.upload.isFailed = true
            this.upload.fileName = file.name
            this.upload.data = rows.filter((_, index) => index > 0)
            this.upload.headColumnNames = rows[0]
          })
        }
      } catch (err) {
        this.upload.isFailed = true
      }
    },
    handleSelectColumn(staticColumnKey, uploadColumnIndex, maxRowNumber) {
      const dataType = this.dataTable.columns.find((col) => col.key === staticColumnKey).type
      this.dataTable.rows[staticColumnKey] = this.upload.data.reduce((acc, row) => {
        row.forEach((col, colIdx) => {
          if (colIdx === uploadColumnIndex) {
            const value = this.getColumnValue(dataType, col)
            acc.push(value)
          }
        })
        return acc
      }, [])
      this.$emit('onChange', this.getForm(maxRowNumber))
    },
    handleUnselectColumn(columnKey, columnIndex, maxRowNumber) {
      this.dataTable.rows[columnKey] = []
      this.$emit('onChange', this.getForm(maxRowNumber))
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/ImportData.vue